import { createContext } from 'react';

import type { NavigationConfirmationHandlers } from './types';

export interface NavigationConfirmationHandlerCtx {
  setHandler: (handlers: NavigationConfirmationHandlers) => void;
  resetHandler: () => void;
  handler: undefined | NavigationConfirmationHandlers;
}

const NavigationConfirmationHandlerContext = createContext<NavigationConfirmationHandlerCtx>({
  setHandler: () => {},
  resetHandler: () => {},
  handler: undefined,
});

NavigationConfirmationHandlerContext.displayName = 'NavigationConfirmationHandlerContext';

export default NavigationConfirmationHandlerContext;
